<template>
  <transition v-if="this.currentStep >= 4" name="fade">
    <div>
      <sol-agora-fisico v-if="this.isClienteFisico"
        :total="this.total"
        :cliente="this.cliente"
        :cepCobranca="this.cepCobranca"
        :codigoPedido="this.codigoPedido"
        :currentStep="this.currentStep"
        :idProject="this.idProject"
        :resultadoSimulacao="this.resultadoSimulacao"
        :token="this.token"
        v-on:previous="previousStep"
        v-on:next="nextStep"
        v-on:setResultadoProposta="setResultadoProposta"
      >
      </sol-agora-fisico>

      <sol-agora-juridico v-if="!this.isClienteFisico"
        :total="this.total"
        :cliente="this.cliente"
        :cepCobranca="this.cepCobranca"
        :codigoPedido="this.codigoPedido"
        :currentStep="this.currentStep"
        :idProject="this.idProject"
        :resultadoSimulacao="this.resultadoSimulacao"
        :token="this.token"
        v-on:previous="previousStep"
        v-on:next="nextStep"
        v-on:setResultadoProposta="setResultadoProposta"
      >
      </sol-agora-juridico>
    </div>
  </transition>
</template>

<script>
import SolAgoraFisico from "./SolAgoraFisico.vue";
import SolAgoraJuridico from "./SolAgoraJuridico.vue";

export default {
  name: "FinancingSolAgora",
  props: {
    total: { type: Number, default: 0 },
    codigoPedido: { type: String, default: 0 },
    cliente: { type: Object, default: null },
    cepCobranca: { type: String, default: "" },
    resultadoSimulacao: { type: Object, default: null },
    idProject: { type: String, default: "" },
    currentStep: { type: Number, default: 0 },
    token: { type: String, default: "" },
  },
  components: {
    SolAgoraFisico,
    SolAgoraJuridico,
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    previousStep: function () {
      this.$emit("previous");
    },

    nextStep: function () {
      this.$emit("next");
    },

    setResultadoProposta: function (resultadoProposta) {
      this.$emit("setResultadoProposta", resultadoProposta);
    },

    setResultadoSimulacao: function (resultadoSimulacao) {
      this.resultadoSimulacao = resultadoSimulacao;
    },
  },
  computed: {
    isClienteFisico: function () {
      return this.cliente.CLI_TIPO == "F";
    },
  },
};
</script>